// bao migrate skip
import Bao from "../../../services/bao-service";
import * as ko from "knockout";
import RoleSummaryReportTab from "./role-summary-report-tab";
class RoleSummaryReportTabDialog {
    SummaryReportId: KnockoutObservable<string>;
    SummaryReportName: KnockoutObservable<string>;
    Parent: RoleSummaryReportTab;
    RoleId: KnockoutObservable<string>;
    constructor($data: {
        SummaryReportName;
        Parent: RoleSummaryReportTab;
    }, $dialog) {
        $.extend(this, $data);
        this.SummaryReportId.subscribe((newval) => {
            this.Parent.TabPage.IsLoading(true);
            return Bao.post("UadmFinitoCustom/RoleSummaryReportTab/GetNewModelForSummaryReport", JSON.stringify({
                roleId: ko.unwrap(this.RoleId),
                summaryReportId: ko.unwrap(newval)
            })).then((serverResult) => {
                ko.map.fromJS(serverResult.Model, this);
            }).always(() => {
                this.Parent.TabPage.IsLoading(false);
            });
        });
    }
    init() {
    }
}
export default RoleSummaryReportTabDialog;